import React, { useState } from 'react';
import '../../pages/LandingPage.css';
import SectionBackground from './SectionBackground';

const PricingCalculatorSection: React.FC = () => {
  const [leaseCount, setLeaseCount] = useState(10);
  const turboPrice = leaseCount * 59;
  const ourPrice = leaseCount * 1;
  const savings = turboPrice - ourPrice;

  return (
    <SectionBackground style={{ padding: '80px 20px', background: '#F0F9FF' }}>
      <div className="container" style={{ maxWidth: '600px' }}>
        <h2 style={{ textAlign: 'center', fontSize: '2.5rem', marginBottom: 40, fontWeight: 700 }}>
          Calculate Your Savings
        </h2>
        <div style={{
          background: 'white',
          padding: '40px',
          borderRadius: '16px',
          boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
        }}>
          <div style={{ marginBottom: '30px' }}>
            <div style={{ fontWeight: 600, display: 'block', marginBottom: '10px' }}>
              How many leases do you create per year?
            </div>
            <input
              type="range"
              min="1"
              max="50"
              value={leaseCount}
              onChange={(e) => setLeaseCount(parseInt(e.target.value))}
              style={{ width: '100%', marginBottom: '10px' }}
            />
            <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '10px' }}>
              <div style={{ fontSize: '2rem', fontWeight: 700, color: 'var(--primary)' }}>
                {leaseCount}
              </div>
              <div style={{ color: 'var(--text-light)' }}>leases/year</div>
            </div>
          </div>
          <div style={{ borderTop: '2px solid var(--border)', paddingTop: '30px' }}>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', textAlign: 'center' }}>
              <div>
                <div style={{ color: 'var(--text-light)', marginBottom: '10px' }}>
                  With TurboTenant
                </div>
                <div style={{ fontSize: '2rem', fontWeight: 700, color: '#DC2626' }}>
                  ${turboPrice}
                </div>
              </div>
              <div>
                <div style={{ color: 'var(--text-light)', marginBottom: '10px' }}>
                  With TenantTerms
                </div>
                <div style={{ fontSize: '2rem', fontWeight: 700, color: 'var(--success)' }}>
                  ${ourPrice}
                </div>
              </div>
            </div>
            <div style={{
              background: '#10B981',
              color: 'white',
              padding: '20px',
              borderRadius: '8px',
              textAlign: 'center',
              marginTop: '30px',
            }}>
              <div style={{ fontSize: '1.5rem', fontWeight: 700 }}>
                You Save ${savings}/year!
              </div>
            </div>
          </div>
        </div>
      </div>
    </SectionBackground>
  );
};

export default PricingCalculatorSection; 